import React from 'react';
import Classwise_Subject from './Classwise_Subject';
import '../../../CommonCSS/SocietyCSS.css'

const Classwise_SubjectApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Classwise Subject</h5>
          </div>  
        </div>
        <Classwise_Subject/>
      </div>
    </div >
  );
};

export default Classwise_SubjectApp;
